/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=3a61b77c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3a61b77c&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\shujukeshihuaqianduan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__